export default __webpack_public_path__ + "static/plugin-hover-ee382117af1c39ba47e153d7fa614d10.png";